import { OrderDetailPrintModel } from "./order-detail-print.model";

export class OrderPrintModel {
  orderId: number = 0;
  enterpriseLogo: string | null = null;
  enterpriseNit: string = '';
  enterpriseName: string = '';
  branchName: string = '';
  consecutive: number = 0;
  branchAddress: string = '';
  branchPhone: string = '';
  orderType: string = '';
  dateOrder: Date = new Date();
  observation: string = '';
  observationRemission: string = '';
  costCenter: string = '';
  observationCostCenter: string = '';
  constructionSiteAddress: string = '';
  constructionSitePhone: string = '';
  constructionSiteClient: string = '';
  constructionSiteClient2: string = '';
  seller: string = '';
  advertiser: string = '';
  userAuthenticated: string = '';
  orderDetails: OrderDetailPrintModel[] = [];
}